import FormControl from "@material-ui/core/FormControl";
import FormGroup from "@material-ui/core/FormGroup";
import React, { FC } from "react";

import Button from "../../../../../components/elements/Button";
import CheckboxButtonOption from "../CheckboxButtonOption";
import classes from "./HubspotPageTypeSelector.module.scss";

type HubspotPageTypeSelectorValues = {
  landingPage: boolean;
  webPage: boolean;
  blogPage: boolean;
};

type HubspotPageTypeSelectorProps = {
  values: HubspotPageTypeSelectorValues;
  handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleGetPages: () => void;
  isLoading: boolean;
};

const HubspotPageTypeSelector: FC<HubspotPageTypeSelectorProps> = ({
  values,
  handleChange,
  handleGetPages,
  isLoading,
}) => {
  const areAnySelectedValues = Object.values(values).some((value) => value);

  return (
    <div className={classes.container}>
      <FormControl component="fieldset" className={classes.fieldSet}>
        <FormGroup className={classes.formGroup}>
          <CheckboxButtonOption
            name="landingPage"
            checked={values.landingPage}
            label="Landing Page"
            handleChange={handleChange}
          />
          <CheckboxButtonOption name="webPage" checked={values.webPage} label="Web Page" handleChange={handleChange} />
          <CheckboxButtonOption
            name="blogPage"
            checked={values.blogPage}
            label="Blog Page"
            handleChange={handleChange}
          />
        </FormGroup>
      </FormControl>
      <Button disabled={!areAnySelectedValues} onClick={handleGetPages} isLoading={isLoading} loaderSize={30}>
        Get Pages
      </Button>
    </div>
  );
};

export default HubspotPageTypeSelector;
